import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTarget = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "target-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc4 {\n        fill: #0573A9;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "secc4",
			d: "M6.99951,13.37421C3.33984,13.37421.3623,10.39667.3623,6.737S3.33984.09979,6.99951.09979c3.66064,0,6.63818,2.97754,6.63818,6.63721h-.00098c0,3.65967-2.97754,6.63721-6.63721,6.63721ZM7.00049,1.09979C3.8916,1.09979,1.3623,3.6286,1.3623,6.737c0,3.10791,2.52881,5.63721,5.63721,5.63721,3.10791,0,5.63721-2.5293,5.63721-5.63721h0c0-1.50586-.58594-2.92139-1.65039-3.98584-1.06445-1.06494-2.48047-1.65137-3.98584-1.65137Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc4",
			d: "M7.00049,10.91913c-2.30615,0-4.18213-1.87598-4.18213-4.18213s1.87598-4.18213,4.18213-4.18213,4.18213,1.87598,4.18213,4.18213-1.87598,4.18213-4.18213,4.18213ZM7.00049,3.55487c-1.75439,0-3.18213,1.42773-3.18213,3.18213s1.42773,3.18213,3.18213,3.18213,3.18213-1.42773,3.18213-3.18213-1.42773-3.18213-3.18213-3.18213Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "secc4",
			d: "M7.00049,8.46307c-.95215,0-1.72705-.7749-1.72705-1.72705,0-.95166.77393-1.72656,1.72559-1.72705h.00146c.95117,0,1.72607.77393,1.72705,1.72559v.00146c0,.95215-.7749,1.72705-1.72705,1.72705ZM7.00049,6.00897h-.00049c-.40088.00049-.72656.32666-.72656.72705,0,.40088.32617.72705.72705.72705s.72705-.32568.72705-.72656c-.00049-.40137-.32666-.72754-.72705-.72754Z"
		})
	]
});
export default SvgTarget;
